export class GlobalUtils {

	public static iframeHandshakeReceived = false;

	/**
	 * Is the app running in an Iframe?
	 * Introduced as part of INNO-2365
	 */
	public static isInsideIframe(): boolean {
		let isInsideIframe = false;
		let cypressFramework = false;
		let isImpersonation = false;

		try {
			isInsideIframe = window.self !== window.top;
			cypressFramework = !!window.parent && !!window.parent['__Cypress__'];

			if (isInsideIframe) {
				const parentHref = window.parent.location?.href ?? '';
				const impersonationUrlPattern =
					/classvaluation\.com\/identity-system\/users\/management\/?([?#].*)?$/;

				isImpersonation = impersonationUrlPattern.test(parentHref);
			}
		} catch (e) {
			isInsideIframe = true;
		}

		return (isInsideIframe || GlobalUtils.iframeHandshakeReceived) && !cypressFramework && !isImpersonation;
	}

	/**
	 * Get the string for tootltip placement
	 *
	 * @returns boolean
	 */
	public static getTooltipPlacement(): string {

		if (GlobalUtils.isInsideIframe()) {
			return 'bottom';
		}

		return 'top';
	}
}
